import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, Building2, Shield, Mail, Phone, MapPin } from 'lucide-react';

export default function MentionsLegales() {
  return (
    <div className="min-h-screen bg-void">
      {/* Header */}
      <header className="border-b border-gray-800 py-4 px-4">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <Link to="/" className="font-orbitron text-xl font-bold text-cyan-400 glitch-subtle">
            L'EFFACEUR
          </Link>
          <Link to="/" className="text-gray-400 hover:text-cyan-400 flex items-center gap-2 text-sm font-mono">
            <ArrowLeft className="w-4 h-4" />
            Retour
          </Link>
        </div>
      </header>
      
      <main className="max-w-4xl mx-auto px-4 py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <h1 className="font-orbitron text-3xl md:text-4xl font-bold text-white mb-4">
            MENTIONS <span className="text-cyan-400">LÉGALES</span>
          </h1>
          <p className="text-gray-400 font-mono text-sm mb-12">// INFORMATIONS_LÉGALES_OBLIGATOIRES</p>
          
          <div className="space-y-12">
            {/* Éditeur */}
            <section className="glass-card p-8 border border-gray-800">
              <div className="flex items-center gap-3 mb-6">
                <Building2 className="w-6 h-6 text-cyan-400" />
                <h2 className="font-orbitron text-xl font-bold text-white">ÉDITEUR DU SITE</h2>
              </div>
              <div className="space-y-4 text-gray-300">
                <p><strong className="text-cyan-400">Raison sociale :</strong> L'EFFACEUR</p>
                <p><strong className="text-cyan-400">Forme juridique :</strong> Entreprise Individuelle</p>
                <p><strong className="text-cyan-400">SIRET :</strong> 947 765 442 00019</p>
                <p><strong className="text-cyan-400">Code APE / NAF :</strong> 70.22Z (Conseil pour les affaires)</p>
                <div className="flex items-start gap-2">
                  <MapPin className="w-4 h-4 text-cyan-400 mt-1 flex-shrink-0" />
                  <p>Toulouse (Haute-Garonne), France</p>
                </div>
                <div className="flex items-center gap-2">
                  <Mail className="w-4 h-4 text-cyan-400" />
                  <p>leffaceur@effaceurpro.fr</p>
                </div>
                <p className="text-gray-500 text-xs italic mt-2">
                  Pour toute demande légale ou de contact, merci d'utiliser l'adresse email ci-dessus.
                  L'adresse postale complète est communiquée sur demande écrite motivée.
                </p>
              </div>
            </section>
            
            {/* Hébergement */}
            <section className="glass-card p-8 border border-gray-800">
              <div className="flex items-center gap-3 mb-6">
                <Shield className="w-6 h-6 text-magenta-400" />
                <h2 className="font-orbitron text-xl font-bold text-white">HÉBERGEMENT</h2>
              </div>
              <div className="space-y-4 text-gray-300">
                <p>Ce site est hébergé par :</p>
                <p><strong className="text-magenta-400">Emergent Labs</strong></p>
                <p>Infrastructure : <strong className="text-cyan-400">Google Cloud Platform (GCP)</strong></p>
                <p className="text-gray-400 text-sm mt-2">
                  Centres de données certifiés ISO 27001, SOC 2 Type II
                </p>
              </div>
            </section>
            
            {/* Propriété intellectuelle */}
            <section className="glass-card p-8 border border-gray-800">
              <h2 className="font-orbitron text-xl font-bold text-white mb-6">PROPRIÉTÉ INTELLECTUELLE</h2>
              <div className="space-y-4 text-gray-300 leading-relaxed">
                <p>
                  La marque <strong className="text-cyan-400">"L'EFFACEUR"</strong>, le logo "Glitch" et l'ensemble
                  des contenus du site (textes, images, code source, design, identité visuelle) sont la propriété
                  exclusive de l'entreprise individuelle L'EFFACEUR.
                </p>
                <p>
                  Toute reproduction, distribution, modification, adaptation, retransmission ou publication
                  de ces éléments est strictement interdite sans l'accord préalable écrit de L'EFFACEUR.
                </p>
              </div>
            </section>

            {/* Responsabilité */}
            <section className="glass-card p-8 border border-gray-800">
              <h2 className="font-orbitron text-xl font-bold text-white mb-6">RESPONSABILITÉ</h2>
              <div className="space-y-4 text-gray-300 leading-relaxed">
                <p>
                  L'EFFACEUR détient une <strong className="text-cyan-400">Assurance Responsabilité Civile Professionnelle (RC Pro)</strong>
                  <span className="text-gray-500 text-xs italic"> — numéro de police communiqué sur demande à leffaceur@effaceurpro.fr</span>.
                </p>
                <p>
                  L'éditeur s'efforce de fournir des informations exactes et à jour, mais ne saurait être tenu
                  responsable des erreurs, omissions ou des résultats obtenus suite à l'utilisation de ces informations.
                </p>
                <p className="text-magenta-400 font-mono text-sm">
                  Clause de non-responsabilité sur les délais tiers : L'EFFACEUR est responsable de l'envoi
                  des demandes de résiliation et du suivi auprès des organismes, mais ne saurait être tenu
                  responsable (a) de la lenteur de traitement des opérateurs, (b) d'un refus de l'organisme
                  de clôturer un contrat pour motif légitime (dette, absence de pièce, etc.), ou (c) de cas
                  de force majeure (panne des services d'un tiers, indisponibilité d'une API publique, etc.).
                </p>
              </div>
            </section>
            
            {/* Juridiction */}
            <section className="glass-card p-8 border border-gray-800">
              <h2 className="font-orbitron text-xl font-bold text-white mb-6">JURIDICTION & LITIGES</h2>
              <div className="space-y-4 text-gray-300 leading-relaxed">
                <p>
                  En cas de litige, <strong className="text-cyan-400">seul le droit français est applicable</strong>.
                </p>
                <p>
                  Les tribunaux compétents sont ceux de <strong className="text-cyan-400">Toulouse</strong>.
                </p>
              </div>
            </section>
            
            {/* MÉDIATEUR DE LA CONSOMMATION */}
            <section className="glass-card p-8 border-2 border-orange-500/50 bg-orange-500/5">
              <h2 className="font-orbitron text-xl font-bold text-white mb-6">MÉDIATION DE LA CONSOMMATION</h2>
              <div className="space-y-4 text-gray-300 leading-relaxed">
                <p>
                  Conformément aux articles <strong className="text-orange-400">L.612-1 et R.612-1 du Code de la consommation</strong>, 
                  tout consommateur a le droit de recourir gratuitement à un médiateur de la consommation en vue de 
                  la résolution amiable d'un litige.
                </p>
                <div className="p-4 bg-orange-500/10 border border-orange-500/30 rounded-lg">
                  <p className="text-orange-400 font-mono font-bold mb-3">MÉDIATEUR COMPÉTENT :</p>
                  <p className="text-white font-medium">CNPM - Médiation de la Consommation</p>
                  <p className="text-gray-300 text-sm mt-2">
                    27 avenue de la Libération, 42400 SAINT-CHAMOND
                  </p>
                  <p className="text-gray-300 text-sm">
                    Site web : <a href="https://www.cnpm-mediation-consommation.eu" target="_blank" rel="noopener noreferrer" className="text-cyan-400 hover:underline">www.cnpm-mediation-consommation.eu</a>
                  </p>
                </div>
                <p className="text-gray-400 text-sm mt-4">
                  Avant de saisir le médiateur, le consommateur doit avoir préalablement tenté de résoudre 
                  son litige directement avec L'EFFACEUR par réclamation écrite à : <strong className="text-cyan-400">leffaceur@effaceurpro.fr</strong>
                </p>
              </div>
            </section>
          </div>
          
          {/* Footer */}
          <div className="mt-12 text-center">
            <p className="text-gray-500 text-sm font-mono">
              Dernière mise à jour : Décembre 2024
            </p>
            <Link 
              to="/confidentialite" 
              className="text-cyan-400 hover:underline text-sm mt-4 inline-block"
            >
              Voir la Charte de Confidentialité →
            </Link>
          </div>
        </motion.div>
      </main>
    </div>
  );
}
